module.exports = {"341802001":"西林街道","341802002":"澄江街道","341802003":"鳌峰街道","341802004":"济川街道","341802005":"敬亭山街道","341802006":"双桥街道","341802009":"向阳街道","341802100":"水阳镇","341802101":"狸桥镇","341802102":"沈村镇","341802103":"古泉镇","341802104":"洪林镇","341802105":"寒亭镇","341802106":"文昌镇","341802107":"孙埠镇","341802109":"杨柳镇","341802110":"水东镇","341802111":"新田镇","341802112":"周王镇","341802113":"溪口镇","341802200":"朱桥乡","341802201":"养贤乡","341802202":"五星乡","341802204":"黄渡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341802.json
// module id = 1153
// module chunks = 0